import React from "react";
import "./implementationprocess.scss";
import timelineImg from "../../assest/page6.png"; // your center image
import Image1 from '../../assest/arrow.png'
import Icon1 from '../../assest/icon1.png'
import Icon2 from '../../assest/icon2.png'
import Icon3 from '../../assest/icon3.png'
import Icon4 from '../../assest/icon4.png'

const steps = [
	{
		iconImage: Icon1,
		title: "DISCOVERY",
		desc: "We assess your customer lifecycle, account workflows, and current challenges to build a strong foundation."
	},
	{
		iconImage: Icon2,
		title: "PLANNING",
		desc: "We define implementation milestones, user roles, and success metrics to ensure alignment and clarity."
	},
	{
		iconImage: Icon3,
		title: "IMPLEMENTATION",
		desc: "We deploy Sciqus AMS with configuration, integration, and validation to ensure readiness and adoption."
	},
	{
		iconImage: Icon4,
		title: "SUPPORT",
		desc: "We provide role-based training and ongoing support to help teams maximize value from the platform."
	}
];

const ImplementationProcess = () => {
	return (
		<section id="amsimplementationprocess" className="implementationProcess">
			
			<h2 className="implementationProcessTitle">Our SciqusAMS Implementation Process</h2>
			
			<div className="implementationProcessArrowImages">
				<img src={Image1} className="arrow arrow1" alt=""/>
				<img src={Image1} className="arrow arrow2" alt=""/>
				<img src={Image1} className="arrow arrow3" alt=""/>
				<img src={Image1} className="arrow arrow4" alt=""/>
			</div>
			
			<div className="implementationProcessTimelineWrapper">
				{/* CENTER IMAGE */}
				<div className="implementationProcessTimelineImage">
					<img src={timelineImg} alt="timeline"/>
				</div>
				
				{/* TEXT BLOCKS */}
				{steps.map ((step, index) => (
					<div key={index} className={`implementationProcessTimelineContent ${index % 2 === 0 ? "implementationProcessleft" : "implementationProcessright"} step${index + 1}`}>
						<div className="ReposniveImages">
							<div className="subReposniveImages">
								<img src={step.iconImage} alt=""/>
							</div>
						</div>
						<div className="subimplementationProcessTimelineContent">
							<h4>{step.title}</h4>
							<p>{step.desc}</p>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default ImplementationProcess;